<template>
    <BreadCrumb PageTitle="Editer l'historique" />
    <EditHistorique/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditHistorique from "@/components/Historique/EditHistorique.vue";


export default defineComponent({
    name: "EditHistoriquePage",
    components: {
        BreadCrumb,
        EditHistorique,
    },
});
</script>